import React from "react";
import "./PageNotFound.css";

function PageNotFound() {
  return (
    <div className="page-not-found-root">
      {/* Логотип PAI */}
      <div className="logo-page-not-found">PAI</div>

      <div className="page-not-found-container">
        <h1>Страница не найдена</h1>
        <p>Мы не можем найти страницу, которую вы ищете.</p>

        <div className="buttons">
          <button
            className="home-button"
            onClick={() => {
              window.location.href = "/courses";
            }}
          >
            Вернуться домой
          </button>

          <button
            className="support-button"
            onClick={() => {
              window.location.href = "mailto:nobigmotion@gmail.com";
            }}
          >
            Написать в поддержку
          </button>
        </div>
      </div>
    </div>
  );
}

export default PageNotFound;
